export const ASPECT_RATIO = 1.25;
export const ASPECT_RATIO_POW = ASPECT_RATIO * ASPECT_RATIO;

export function grid(row, col, height) {
  const pHeight = height / row;
  const pWidth = pHeight / ASPECT_RATIO;

  let gridTemplate = '';

  for (let i = 0; i < row; i++) {
    gridTemplate += `'`;
    for (let j = 0; j < col; j++) {
      gridTemplate += `p${i * col + j + 1} `;
    }
    gridTemplate += `' ${pHeight}px `;
  }

  gridTemplate += ` / ${`${pWidth}px `.repeat(col)}`;

  return {
    gridTemplate,
    photos: gridPhotos(1, row * col, pWidth, pHeight)
  };
}

export function gridPhotos(start, end, width, height, rotation = 0, prefix = 'p') {
  const photos = [];

  for (let i = start; i <= end; i++) {
    photos.push({
      gridArea: `${prefix}${i}`,
      width,
      height,
      rotation
    });
  }

  return photos;
}
